export default function AdultPartyContentSection() {
  return (
    <section className="py-6 md:py-16 bg-[#FCF8F8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 place-items-start event-box2">
          {/* Left Content */}
          <div className="space-y-8">
            <h1 className="text-4xl font-bold text-[#00889D]">
              Adult Party
            </h1>

            <div>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Celebrate differently — movement, music, mindfulness!
                Whether it’s a birthday, bachelorette, team event, or a night out with friends, we offer a one-of-a-kind experience that blends wellness, style, and joy.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Move, laugh, and reconnect through  <span className="text-[#00889D] font-semibold">Dance or
                Fitness</span>, or slow down with a calming <span className="text-[#00889D] font-semibold">Yoga,
                Meditation, Sound Bathes or Tea Ceremony</span>.
              </p>

              <h3 className="text-2xl text-[#00889D] font-bold mb-2">Cost: $499 per party</h3>
            </div>

            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700"><strong>2 hours</strong></p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700"><strong>1 hour of workshop</strong> of your choice (Yoga, Meditation, Fitness, Dance)
                </p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700"><strong>1 hour of celebration</strong></p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700"><strong>$100 for 1 extra hour</strong> of celebration or Tea Ceremony or Sound Bath</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700"><strong>max 20 people capacity</strong></p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700">Parties are held on <strong className="text-[#00889D]">Saturday,
                  Sunday</strong> afternoon</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700">Feel free to bring cake, snacks and refreshments. Pizza pizza is just
                  next
                  door</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-gray-700">Let us know if you want recommendations <span
                    className="text-[#00889D] font-semibold">very special cake</span></p>
              </div>
            </div>
          </div>

          {/* Right Images */}
          <div className="pt-0 md:pt-20">
            <div className="grid py-5">
              <div className="rounded-lg overflow-hidden">
                <img
                    src="/img/events-adult1.png"
                    alt="Adult Party"
                    className="w-full object-cover"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pb-4 md:pb-20">
              <div className="aspect-square rounded-lg overflow-hidden">
                <img
                    src="/img/events-adult2.png"
                    alt="Adult Party"
                    className="w-full h-full object-cover"
                />
              </div>
              <div className="aspect-square rounded-lg overflow-hidden">
                <img
                    src="/img/events-adult3.png"
                    alt="Adult Party"
                    className="w-full h-full object-cover"
                />
              </div>
              <div className="aspect-square rounded-lg overflow-hidden">
                <img
                    src="/img/events-adult4.png"
                    alt="Adult Party"
                    className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);
}